export const READING_FOR_EVIDENCE_ACTIVITIES = "Reading for Evidence Activities"
export const THIRD_GRADE_TEKS_ACTIVITY_PACKS = "3rd Grade TEKS Activity Packs"
export const FOURTH_GRADE_TEKS_ACTIVITY_PACKS = "4th Grade TEKS Activity Packs"
export const FIFTH_GRADE_TEKS_ACTIVITY_PACKS = "5th Grade TEKS Activity Packs"
export const SIXTH_GRADE_TEKS_ACTIVITY_PACKS = "6th Grade TEKS Activity Packs"
export const SEVENTH_GRADE_TEKS_ACTIVITY_PACKS = "7th Grade TEKS Activity Packs"
export const EIGHTH_GRADE_TEKS_ACTIVITY_PACKS = "8th Grade TEKS Activity Packs"
export const ENGLISH_I_TEKS_ACTIVITY_PACKS = "English I TEKS Activity Packs"
export const ENGLISH_II_TEKS_ACTIVITY_PACKS = "English II TEKS Activity Packs"

export const TEKS_COURSE_PAGE = "teks-course-page"

export const TEKS_PREMIUM_TOOLTIP_TEXT = `<p>Unlock all TEKS assignments with a Quill Premium school or district partnership.<br/><a href="${window.postbuildEnv.DEFAULT_URL}/premium" rel="noopener noreferrer" target="_blank">Learn more.</a></p>`
export const TEKS_IMAGE_CREDIT_TOOLTIP_TEXT = '<p>Photo by <a href="https://unsplash.com/@prince_perry" rel="noopener noreferrer" target="_blank">Perry Merrity II</a> on <a href="https://unsplash.com/photos/a-bunch-of-flags-that-are-hanging-in-the-air-zLbx38fVZ7c" rel="noopener noreferrer" target="_blank">Unsplash</a>.</p>'

export const chevronLeftImgSrc = `${window.postbuildEnv.CDN_URL}/images/icons/xs/chevron-left.svg`
export const teksHeaderImgSrc = `${window.postbuildEnv.CDN_URL}/images/pages/teks_page/texas-flags@2x.png`

export const NOVEL_BASED_ACTIVITY_PACK_IDS = [1079, 1050, 1067, 1080, 1051, 552, 1071, 1069, 1123]

export const FISHTANK_ELA_GRADE_7_ACTIVITY_PACKS = "Fishtank ELA Grade 7"
export const FISHTANK_ELA_GRADE_8_ACTIVITY_PACKS = "Fishtank ELA Grade 8"
export const FISHTANK_ELA_ALIGNED_QUILL_ACTIVITIES = "Fishtank ELA-aligned Quill Activities"

export const LITERATURE_COURSE_PAGE = "literature-course-page"

export const fishtankGradeHeaderImgSrc = `${window.postbuildEnv.CDN_URL}/images/pages/literature_subject_page/fishtank_grade_header.webp`
export const FISHTANK_IMAGE_CREDIT_TOOLTIP_TEXT = '<p>Photo by Hanife Altan on <a href="https://www.pexels.com/photo/books-on-wooden-shelves-7643400/" rel="noopener noreferrer" target="_blank">Pexels</a>.</p>'

